<template>
    <div class="enterprise-page">
        <!-- 企业基本信息卡片 -->
        <div class="whitebox centerpage py-4">
            <div class="d_blocktitle">
                <i class="title-icon title-icon1"></i>
                <h3 class="ctitle">{{ companyinfor.title }}</h3>
            </div>
            <ul class="oh conpany-infor-new">
                <li class="inforLine inforLine-3">
                    <span class="label">注册资本：</span>
                    <span class="infortext">{{ companyinfor.regCapital || '-' }}</span>
                </li>
                <li class="inforLine inforLine-3">
                    <span class="label">实缴资本：</span>
                    <span class="infortext">{{ companyinfor.paidCapital || '-' }}</span>
                </li>
                <li class="inforLine inforLine-3">
                    <span class="label">组织机构代码：</span>
                    <span class="infortext">{{ companyinfor.orgCode || '-' }}</span>
                </li>
                <li class="inforLine inforLine-3">
                    <span class="label">企业类型：</span>
                    <span class="infortext">{{ companyinfor.type || '-' }}</span>
                </li>
                <li class="inforLine inforLine-3">
                    <span class="label">员工人数：</span>
                    <span class="infortext">{{ companyinfor.insurePerson > 0 ? companyinfor.insurePerson : '-' }}</span>
                </li>
                <li class="inforLine inforLine-3" v-show="companyinfor.isIpo">
                    <span class="label">上市时间：</span>
                    <span class="infortext">{{ companyinfor.ipoTime || '-' }}</span>
                </li>
                <li class="inforLine inforLine-3" v-show="companyinfor.isIpo">
                    <span class="label">A股代码：</span>
                    <span class="infortext">{{ companyinfor.stockCode || '-' }}</span>
                </li>
                <li class="inforLine inforLine-3" v-show="companyinfor.abbr">
                    <span class="label">股票简称：</span>
                    <span class="infortext">{{ companyinfor.abbr }}</span>
                </li>
                <li class="inforLine inforLine-3">
                    <span class="label">注册号：</span>
                    <span class="infortext">{{ companyinfor.regNo || '-' }}</span>
                </li>
                <li class="inforLine inforLine-3">
                    <span class="label">纳税人识别号：</span>
                    <span class="infortext">{{ companyinfor.taxNo || '-' }}</span>
                </li>
                <li class="inforLine inforLine-3">
                    <span class="label">所属行业：</span>
                    <span class="infortext">{{ companyinfor.industry || '-' }}</span>
                </li>
                <li class="inforLine inforLine-3 longlabel" v-if="realController.length > 0">
                    <span class="label">疑似实际控制人：</span>
                    <span class="infortext">{{ realController[0].title }}</span>
                </li>
                <li class="inforLine inforLine-3" v-if="realController.length > 0">
                    <span class="label">总股权比例：</span>
                    <span class="infortext">{{ realController[0].proportion }}</span>
                </li>
                <li class="inforLine inforLine-one" v-show="extendinfor.coreProduct">
                    <span class="label">企业核心产品：</span>
                    <el-tag effect="plain" class="mr-1" v-for="(item, i) in productlist" :key="i">{{ item }}</el-tag>
                </li>
                <li class="inforLine inforLine-one" v-show="extendinfor.productName">
                    <span class="label">主营产品名称：</span>
                    <span class="infortext">{{ extendinfor.productName }}</span>
                </li>
                <li class="inforLine inforLine-one" v-show="extendinfor.productType">
                    <span class="label">主营产品类型：</span>
                    <span class="infortext">{{ extendinfor.productType }}</span>
                </li>
                <li class="inforLine inforLine-one" v-show="companyinfor.mainBusiness">
                    <span class="label">主营业务：</span>
                    <span class="infortext">{{ companyinfor.mainBusiness }}</span>
                </li>
                <li class="inforLine inforLine-one" v-if="companyinfor.summary && companyinfor.summary.length > 0">
                    <span class="label">企业简介：</span>
                    <span class="infortext">{{ companyinfor.summary }}</span>
                </li>
            </ul>
        </div>

        <!-- 楼层导航（吸顶） -->
        <div class="floor-nav-wrapper" :class="{ 'is-sticky': isSticky }" ref="floorNav">
            <div class="floor-nav" @mouseenter="showAllSubmenu = true" @mouseleave="showAllSubmenu = false">
                <div v-for="floor in floorList" :key="floor.id" class="floor-nav-item"
                    :class="{ active: activeFloor === floor.id }" @click="scrollToFloor(floor.id)">
                    <span class="floor-name">{{ floor.name }}</span>
                </div>
            </div>

            <!-- 全部子项面板：移入导航栏时显示 -->
            <transition name="fade">
                <div v-show="showAllSubmenu" class="all-submenu-panel">
                    <div class="all-submenu-grid">
                        <div v-for="floor in floorList" :key="floor.id" class="submenu-group">
                            <div class="submenu-group-title">{{ floor.name }}</div>
                            <div v-for="sub in floor.children" :key="sub.id" class="submenu-group-item"
                                @click="scrollToSubSection(floor.id, sub.id)">
                                {{ sub.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <!-- 楼层内容区域 -->
        <div class="floor-content-wrapper">
            <div v-for="floor in floorList" :key="floor.id" :id="floor.id" class="floor-section">
                <div class="floor-header">
                    <div class="floor-title-bar">
                        <i class="floor-icon"></i>
                        <h3>{{ floor.name }}</h3>
                    </div>
                </div>

                <!-- 子模块内容 -->
                <div v-for="sub in floor.children" :key="sub.id" :id="sub.id" class="sub-section">
                    <div class="sub-section-title">{{ sub.name }}</div>
                    <div class="sub-section-content">
                        <!-- 各子模块对应组件 -->
                        <component :is="sub.component" v-if="sub.component" />
                        <div v-else class="placeholder-content">
                            <p>{{ sub.name }} 内容区域</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 右侧快速返回顶部 -->
        <div class="back-to-top" v-show="showBackTop" @click="scrollToTop">
            <i class="el-icon-arrow-up"></i>
            <span>顶部</span>
        </div>
    </div>
</template>

<script>
import business from './enterpriseInc/business.vue';

export default {
    components: {
        business
    },
    data() {
        return {
            id: this.$route.query.id || null,
            companyinfor: {
                title: '123213',
                regCapital: '',
                paidCapital: '',
                orgCode: '',
                type: '',
                insurePerson: '',
                isIpo: '',
                ipoTime: '',
                stockCode: '',
                abbr: '',
                regNo: '',
                taxNo: '',
                industry: '',
                mainBusiness: '',
                summary: '',
            },
            extendinfor: {
                coreProduct: '',
                productName: '',
                productType: '',
            },
            realController: [],
            productlist: [],

            // 楼层导航数据（与截图对应）
            floorList: [
                {
                    id: 'baseInfo',
                    name: '基本信息',
                    children: [
                        { id: 'industryInfo', name: '工商信息', component: null },
                        { id: 'contactVIP', name: '联系人VIP', component: null },
                        { id: 'industryInfo2', name: '工商信息-分类标签', component: null },
                        { id: 'taxLevel', name: '纳税信用等级', component: null },
                        { id: 'annualReport', name: '企业年报', component: null },
                        { id: 'changeRecord', name: '变更记录', component: null },
                    ]
                },
                {
                    id: 'personnel',
                    name: '人员信息',
                    children: [
                        { id: 'employees', name: '从业人员', component: null },
                        { id: 'keyPersonnel', name: '主要人员', component: null },
                        { id: 'executives', name: '高管信息', component: null },
                        { id: 'historyExecutives', name: '历史高管', component: null },
                    ]
                },
                {
                    id: 'equity',
                    name: '股权关系',
                    children: [
                        { id: 'beneficiary', name: '受益人信息', component: null },
                        { id: 'controller', name: '实际控制人', component: null },
                        { id: 'shareholders', name: '股东信息', component: null },
                        { id: 'branches', name: '分支机构', component: null },
                        { id: 'investment', name: '对外投资', component: null },
                    ]
                },
                {
                    id: 'projects',
                    name: '项目信息',
                    children: [
                        { id: 'landInfo', name: '拿地信息', component: null },
                        { id: 'projectApproval', name: '项目审批', component: null },
                        { id: 'biddingNotice', name: '招投标公告', component: null },
                        { id: 'biddingResult', name: '招投标结果', component: null },
                        { id: 'biddingRelation', name: '招投标关系', component: null },
                        { id: 'biddingText', name: '招投标正文', component: null },
                    ]
                },
                {
                    id: 'business',
                    name: '经营信息',
                    children: [
                        { id: 'adminLicense', name: '行政许可', component: null },
                        { id: 'qualification', name: '资质证书', component: null },
                        { id: 'techAchievement', name: '科技成果', component: null },
                        { id: 'standardInfo', name: '标准信息', component: null },
                    ]
                },
                {
                    id: 'businessRisk',
                    name: '经营风险',
                    children: [
                        { id: 'equityPledge', name: '股权质押', component: null },
                        { id: 'adminPenalty', name: '行政处罚', component: null },
                        { id: 'violation', name: '违规事件', component: null },
                        { id: 'taxArrears', name: '欠税信息', component: null },
                    ]
                },
                {
                    id: 'judicial',
                    name: '司法信息',
                    children: [
                        { id: 'courtNotice', name: '法院公告', component: null },
                        { id: 'filingInfo', name: '立案信息', component: null },
                        { id: 'courtSession', name: '开庭公告', component: null },
                        { id: 'judgment', name: '裁判文书', component: null },
                        { id: 'finalCase', name: '终本案件', component: null },
                    ]
                },
                {
                    id: 'judicialRisk',
                    name: '司法风险',
                    children: [
                        { id: 'highConsumption', name: '限制高消费', component: null },
                        { id: 'executedPerson', name: '被执行人', component: null },
                        { id: 'dishonest', name: '失信被执行人', component: null },
                        { id: 'judicialAuction', name: '司法拍卖', component: null },
                        { id: 'judicialAssist', name: '司法协助', component: null },
                        { id: 'bankruptcy', name: '破产重组', component: null },
                    ]
                }
            ],

            activeFloor: 'baseInfo',
            hoverFloor: null,
            isSticky: false,
            showBackTop: false,
            navOffsetTop: 0,
            scrollTimer: null,
            showAllSubmenu: false,   // 控制全部子菜单显示
            hoverFloor: null,        // 可以保留，如果还需要高亮当前项
        }
    },

    mounted() {
        this.getEnterpriseBaseInfo();
        this.$nextTick(() => {
            this.navOffsetTop = this.$refs.floorNav ? this.$refs.floorNav.offsetTop : 0;
            window.addEventListener('scroll', this.handleScroll, { passive: true });
        });
    },

    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
        if (this.scrollTimer) clearTimeout(this.scrollTimer);
    },

    methods: {
        // 获取企业基本信息
        getEnterpriseBaseInfo() {
            const ajaxUrl = this.$api.common.constructionUnit.EnterpriseBaseInfo() + '?unitId=' + this.id;
            this.$axios.get(ajaxUrl).then(res => {
                console.log('企业基本信息', res);
                if (res.success) {
                    this.companyinfor = res.data || {};
                    this.getEnterpriseDetail(this.companyinfor.enterprise_id);
                }
            });
        },

        getEnterpriseDetail(enterpriseId) {
            const ajaxUrl = this.$api.common.constructionUnit.EnterpriseDetail() + '?enterpriseId=' + enterpriseId;
            this.$axios.get(ajaxUrl).then(res => {
                console.log('企业详情', res);
                if (res.success) {
                    this.extendinfor = res.data || {};
                    this.realController = res.data.realController || [];
                    this.productlist = res.data.productList || [];
                }
            });
        },

        // 滚动到指定楼层
        scrollToFloor(floorId) {
            const element = document.getElementById(floorId);
            if (element) {
                const offset = this.isSticky ? 60 : this.navOffsetTop + 60;
                const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({ top, behavior: 'smooth' });
                this.activeFloor = floorId;
            }
        },

        // 滚动到指定子模块
        scrollToSubSection(floorId, subId) {
            const element = document.getElementById(subId);
            if (element) {
                const offset = this.isSticky ? 70 : this.navOffsetTop + 70;
                const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({ top, behavior: 'smooth' });
                this.activeFloor = floorId;
                this.hoverFloor = null;
            }
        },

        // 滚动监听
        handleScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            // 吸顶判断
            this.isSticky = scrollTop >= this.navOffsetTop;

            // 返回顶部显示
            this.showBackTop = scrollTop > 500;

            // 防抖：更新当前高亮楼层
            if (this.scrollTimer) clearTimeout(this.scrollTimer);
            this.scrollTimer = setTimeout(() => {
                this.updateActiveFloor();
            }, 100);
        },

        // 更新当前激活的楼层
        updateActiveFloor() {
            const sections = this.floorList.map(f => document.getElementById(f.id));
            const scrollTop = window.pageYOffset + (this.isSticky ? 70 : this.navOffsetTop + 70);

            for (let i = sections.length - 1; i >= 0; i--) {
                if (sections[i] && sections[i].offsetTop <= scrollTop) {
                    this.activeFloor = this.floorList[i].id;
                    break;
                }
            }
        },

        // 返回顶部
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }
}
</script>

<style lang="scss" scoped>
.enterprise-page {
    background: #f5f7fa;
    min-height: 100vh;
}

.whitebox {
    padding: 40px;
    background: #fff;
    margin-bottom: 16px;

    .d_blocktitle {
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        padding-bottom: 16px;
        border-bottom: 2px solid #e8ecf1;

        .title-icon {
            width: 4px;
            height: 20px;
            background: #1a73e8;
            border-radius: 2px;
            margin-right: 12px;
        }

        .ctitle {
            font-size: 20px;
            font-weight: 600;
            color: #1a1a1a;
            margin: 0;
        }
    }
}

.conpany-infor-new {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;

    .inforLine {
        display: flex;
        align-items: flex-start;
        margin-bottom: 12px;
        line-height: 1.6;

        &.inforLine-3 {
            width: 33.333%;
            padding-right: 20px;
        }

        &.inforLine-one {
            width: 100%;
        }

        .label {
            color: #666;
            font-size: 14px;
            white-space: nowrap;
            min-width: 100px;
        }

        .infortext {
            color: #333;
            font-size: 14px;
            word-break: break-all;
        }

        &.longlabel .label {
            min-width: 120px;
        }
    }
}

/* ===== 楼层导航样式 ===== */
.floor-nav-wrapper {
    background: #fff;
    border-bottom: 1px solid #e8ecf1;
    position: relative;
    z-index: 100;
    transition: all 0.3s ease;

    &.is-sticky {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    }
}

.floor-nav {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 56px;
}

.floor-nav-item {
    flex: 1;
    text-align: center;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    font-size: 15px;
    color: #555;
    font-weight: 500;
    transition: all 0.2s ease;
    border-bottom: 3px solid transparent;

    &:hover {
        color: #1a73e8;
        background: #f8fafc;
    }

    &.active {
        color: #1a73e8;
        border-bottom-color: #1a73e8;
        font-weight: 600;
    }

    .floor-name {
        pointer-events: none;
    }
}

/* 全部子项面板 */
.all-submenu-panel {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    border: 1px solid #e8ecf1;
    border-top: none;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
    padding: 20px 24px;
    z-index: 200;
}

.all-submenu-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr); // 4列，可按需调整
    gap: 16px;
    max-width: 1200px;
    margin: 0 auto;
}

.submenu-group {
    padding: 8px;
}

.submenu-group-title {
    font-size: 14px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
}

.submenu-group-item {
    padding: 6px 0;
    font-size: 13px;
    color: #555;
    cursor: pointer;
    transition: all 0.15s;

    &:hover {
        color: #1a73e8;
    }
}

/* 移除原来每个 item 里的 submenu-panel 相关样式 */

.submenu-item {
    padding: 10px 20px;
    font-size: 13px;
    color: #555;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
        background: #f0f7ff;
        color: #1a73e8;
    }
}

/* 过渡动画 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s, transform 0.2s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
    transform: translateX(-50%) translateY(-5px);
}

/* ===== 楼层内容区域 ===== */
.floor-content-wrapper {
    max-width: 1200px;
    margin: 0 auto;
    padding: 24px 0 60px;
}

.floor-section {
    margin-bottom: 24px;
    background: #fff;
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.floor-header {
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f0f0;
}

.floor-title-bar {
    display: flex;
    align-items: center;

    .floor-icon {
        width: 4px;
        height: 18px;
        background: #1a73e8;
        border-radius: 2px;
        margin-right: 10px;
    }

    h3 {
        font-size: 18px;
        font-weight: 600;
        color: #1a1a1a;
        margin: 0;
    }
}

.sub-section {
    margin-bottom: 32px;

    &:last-child {
        margin-bottom: 0;
    }
}

.sub-section-title {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
    padding-left: 12px;
    border-left: 3px solid #1a73e8;
}

.sub-section-content {
    background: #fafbfc;
    border-radius: 6px;
    padding: 20px;
    min-height: 120px;
}

.placeholder-content {
    color: #999;
    text-align: center;
    padding: 40px 0;

    p {
        margin: 0;
        font-size: 14px;
    }
}

/* 返回顶部 */
.back-to-top {
    position: fixed;
    right: 40px;
    bottom: 60px;
    width: 48px;
    height: 48px;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 999;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);

        i,
        span {
            color: #1a73e8;
        }
    }

    i {
        font-size: 16px;
        color: #666;
        margin-bottom: 2px;
    }

    span {
        font-size: 11px;
        color: #666;
    }
}

/* 吸顶时的内容补偿 */
.is-sticky+.floor-content-wrapper {
    padding-top: 72px;
}

/* 响应式 */
@media (max-width: 768px) {
    .floor-nav {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;

        .floor-nav-item {
            flex: 0 0 auto;
            padding: 0 16px;
            font-size: 14px;
        }
    }

    .conpany-infor-new .inforLine.inforLine-3 {
        width: 50%;
    }
}
</style>